import { useMemo } from 'react';

import { WORKSPACE_STATUS, SUBSCRIPTION_STATUS } from '#constants/subscriptions';
import { isFreeTrialOver, onLessThanTenDaysOfFreeTrial } from '#models/workspace';

const getFreeTrialEndingStatus = workspace =>
  onLessThanTenDaysOfFreeTrial(workspace) ? WORKSPACE_STATUS.FREE_TRIAL_ENDING : WORKSPACE_STATUS.FREE_TRIAL;

const getFreeTrialStatus = (workspace, freeTrialOver) =>
  freeTrialOver ? WORKSPACE_STATUS.FREE_TRIAL_OVER : getFreeTrialEndingStatus(workspace);

const subscriptionToLawyerStatus = freeTrialOver => ({
  [SUBSCRIPTION_STATUS.CANCELLED]: freeTrialOver
    ? WORKSPACE_STATUS.SUBSCRIPTION_OVER
    : WORKSPACE_STATUS.SUBSCRIPTION_CANCELLED,
  [SUBSCRIPTION_STATUS.PAUSED]: WORKSPACE_STATUS.SUBSCRIPTION_PAUSED
});

// The subscription dates (hasValidAccess, computed by the backend from nextPaymentDate) take priority over the
// free trial ones: an authorized subscription whose period is over is not valid anymore
const getSubscriptionStatus = ({ workspace, subscriptionStatus, freeTrialOver }) =>
  subscriptionToLawyerStatus(freeTrialOver)[subscriptionStatus] ||
  (workspace?.hasValidAccess === false ? WORKSPACE_STATUS.SUBSCRIPTION_OVER : WORKSPACE_STATUS.NORMAL);

export const useSubscriptionStatus = workspace => {
  const freeTrialOver = isFreeTrialOver(workspace);
  const { status: subscriptionStatus, plan } = workspace?.mercadoPagoSubscription || {};
  const freeTrial = !plan;
  const status = useMemo(
    () =>
      freeTrial
        ? getFreeTrialStatus(workspace, freeTrialOver)
        : getSubscriptionStatus({ workspace, subscriptionStatus, freeTrialOver }),
    [workspace]
  );

  return status;
};
